<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import { useAdmin } from 'dashboard/composables/useAdmin';

const emit = defineEmits(['add', 'import', 'export', 'deleteAll']);

const { t } = useI18n();

const { isAdmin } = useAdmin();

const contactMenuItems = computed(() => {
  const items = [
    {
      label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.ADD_CONTACT'),
      action: 'add',
      value: 'add',
      icon: 'i-lucide-plus',
    },
    {
      label: t(
        'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT'
      ),
      action: 'export',
      value: 'export',
      icon: 'i-lucide-upload',
    },
    {
      label: t(
        'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT'
      ),
      action: 'import',
      value: 'import',
      icon: 'i-lucide-download',
    },
  ];

  if (isAdmin.value) {
    items.push({
      label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.DELETE_ALL'),
      action: 'delete-all',
      value: 'delete-all',
      icon: 'i-lucide-trash-2',
      class: 'text-n-ruby-11',
    });
  }

  // Business Card Upload feature disabled
  // {
  //   label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.BUSINESS_CARD_UPLOAD'),
  //   action: 'business-card-upload',
  //   value: 'business-card-upload',
  //   icon: 'i-lucide-credit-card',
  // },

  return items;
});

const showActionsDropdown = ref(false);

const handleContactAction = ({ action }) => {
  if (action === 'add') {
    emit('add');
  } else if (action === 'import') {
    emit('import');
  } else if (action === 'export') {
    emit('export');
  } else if (action === 'delete-all') {
    emit('deleteAll');
  }
  // Business Card Upload feature disabled
  // } else if (action === 'business-card-upload') {
  //   emit('business-card-upload');
  // }
  showActionsDropdown.value = false;
};
</script>

<template>
  <div v-on-clickaway="() => (showActionsDropdown = false)" class="relative">
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="contactMenuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleContactAction($event)"
    />
  </div>
</template>
